import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import InputField from "../../../Component/UI/InputField/InputField";
import classes from "../../../assets/css/events.module.css";
import TimePickers from "../../UI/TimePicker";
import { Input, Select, TextArea } from "../../../Component/UI/CustomInputs";
import { DatePicker } from "../../UI/DatePicker";
import PaperWrapper from "../../../Component/UI/PaperWrapper/PaperWrapper";
import CustomizedButtons from "../../../Component/UI/Button/CustomizeButton";
import axios from "../../../config/axiosConfig";
import { StringDtoY } from "../../../config/formattedDate";
import { SelectCard2 } from "../../UI/SelectCard2";
import BasicBreadcrumbs from "../../../Component/UI/BreadCrumb/BreadCrumbs";
import TimerForEditEvent from "./TimerForEditEvent";
import moment from "../../../../node_modules/moment/moment";
import toast, {
  Toaster,
} from "../../../../node_modules/react-hot-toast/dist/index";
import { UploadProfile } from "../../../Component/UI/UploadProfile";

export const AddEvent = () => {
  const today = StringDtoY(new Date());

  let mockData = {
    type: 1,
    event_date: today,
    name: "",
    coordinator: "",
    start_time: "10:00",
    end_time: "11:00",
    description: "",
    staff: "staff",
    weblink: "",
  };

  const [data, setData] = useState(mockData);
  const [err, setErr] = useState({});
  const [dateSelected, setDateSelected] = useState(new Date());
  const navigate = useNavigate();

  const getSelectedOption = (option) => {
    let typeStatus;
    if (option === "Online") {
      typeStatus = 1;
    } else {
      typeStatus = 0;
    }
    setData({ ...data, type: typeStatus });
  };

  const getSelectedDate = (e) => {
    setData({
      ...data,
      event_date: StringDtoY(e),
    });
    setDateSelected(e);
  };

  const handleCancel = () => {
    navigate("/events");
  };
  const handleSubmit = async () => {
    // console.log(data.start_time, "data", data.end_time);

    const currentDate = moment(new Date()).format("YYYY-MM-DD");

    const selectedStartTime = moment(
      currentDate + " " + data.start_time,
      "YYYY-MM-DD hh:mm"
    );
    const selectedEndTime = moment(
      currentDate + " " + data.end_time,
      "YYYY-MM-DD hh:mm"
    );

    const diffMin = selectedEndTime.diff(selectedStartTime, "seconds");
    const endDiff = selectedEndTime.diff(moment(), "minutes");
    const startDiff = selectedStartTime.diff(moment(), "minutes");

    const eventDateDiff = moment().diff(
      moment(dateSelected).format("YYYY-MM-DD hh:mm"),
      "hours"
    );

    const formData = new FormData();
    for (let key in data) formData.append(key, data[key]);

    if (diffMin > 0) {
      if (endDiff < 0 && eventDateDiff >= 0) {
        toast.error("End time should be more than current time!");
      } else if (startDiff < 0 && eventDateDiff >= 0) {
        toast.error("Start time should be more than current time!");
      } else {
        await axios
          .post("/admin/add/events", formData)
          .then((res) => {
            console.log(res);
            setErr(res?.data?.error);
            if (res.data.status === true) {
              toast.success("Event added successfully!");
              navigate("/events");
            }
          })
          .catch((err) => console.error(err));
      }
    } else {
      toast.error("End time should be more than start time!");
    }
  };

  const getStartTime = (e) => {
    setData({ ...data, start_time: e.target.value });
  };

  const getEndTime = (e) => {
    setData({ ...data, end_time: e.target.value });
  };

  console.log(data, "data---");

  const links = [{ path: "/events", linkText: "Events" }];

  return (
    <>
      <Toaster />
      <BasicBreadcrumbs link={links} text="Add Events">
        <div className={classes.addEvent}>
          <div className={classes.avatar}>
            <UploadProfile
              name="banner_image"
              upload={(value) => {
                setData({ ...data, banner_image: value });
              }}
            />
            <p style={{ color: "red", marginTop: "10px", fontSize: "12px" }}>
              {err?.banner_image}
            </p>
          </div>
          <div>
            <div className={classes.general_obv}>
              <div>
                <Input
                  label="Name"
                  type="text"
                  value={data.name}
                  error={err?.name}
                  onChange={(e) => {
                    setData({ ...data, name: e.target.value });
                  }}
                  maxlength="59"
                />
              </div>
              <div>
                <DatePicker
                  label="Date"
                  minDate={new Date()}
                  getSelectedDate={getSelectedDate}
                />
              </div>
            </div>
            <div className={classes.general_obv}>
              <div>
                <SelectCard2
                  options={["Online", "Offline"]}
                  label="Type of Event"
                  error={err?.type}
                  style={{
                    // border: "1px solid #dadada",
                    width: "315px",
                    borderRadius: "8px",
                  }}
                  labelstyle={{ width: "50%", fontSize: "16px" }}
                  getSelectedOption={getSelectedOption}
                  value={data.type === 1 ? "Online" : "Offline"}
                />
              </div>
              <div>
                <Input
                  label="Coordinator"
                  type="text"
                  error={err?.coordinator}
                  value={data.coordinator}
                  onChange={(e) => {
                    setData({ ...data, coordinator: e.target.value });
                  }}
                />
              </div>
            </div>
            <div className={classes.general_obv}>
              <div>
                <TimerForEditEvent
                  labelName={"Start Time"}
                  defaultValue={data?.start_time}
                  onChange={getStartTime}
                />
              </div>
              <div>
                <TimerForEditEvent
                  labelName={"End Time"}
                  defaultValue={data?.end_time}
                  onChange={getEndTime}
                />
              </div>
            </div>
            <div className={classes.general_obv}>
              <div>
                <Input
                  label="Speaker Name"
                  type="text"
                  error={err?.speaker_name}
                  value={data.speaker_name}
                  onChange={(e) => {
                    setData({ ...data, speaker_name: e.target.value });
                  }}
                />
              </div>
              <div>
                <Input
                  label="Webinar Link"
                  type="text"
                  error={err?.weblink}
                  value={data.weblink}
                  onChange={(e) => {
                    setData({ ...data, weblink: e.target.value });
                  }}
                />
              </div>
            </div>
            <div className={classes.general_obv}>
              <TextArea
                label="Description"
                type="text"
                error={err?.description}
                width="712px"
                height="96px"
                value={data.description}
                //  maxlength="200"
                onChange={(e) => {
                  setData({ ...data, description: e.target.value });
                }}
              />
            </div>
            <div className={classes.AddEventButtonsWrapper}>
              <CustomizedButtons
                click={handleCancel}
                ButtonLabel={"Cancel"}
                btncoloractive={"active"}
              />
              <CustomizedButtons ButtonLabel={"Save"} click={handleSubmit} />
            </div>
          </div>
        </div>
      </BasicBreadcrumbs>
    </>
  );
};
